import React from "react";
import { toElementProps } from "../../Element";
import useLoremIpsum from "../technical/useLoremIpsum.jsx";

export function ButtonStyles(params = {}) {
    const { eStyles, palette } = params;

    // eStyles
    const shadowColor = "rgba(80, 80, 80, 50%)";

    let fontWeight = "inherit";
    let borderColor = "inherit";
    let borderRadius = "inherit";
    let borderRadiusHover = borderRadius;
    let borderWidth = "1px";
    let boxShadow = "none";
    let inset = "-4px";
    const ani = Math.abs(parseFloat(inset)); // Absolute number inset

    let gradientBorderColor = "inherit";
    let gradientBackgroundImage = "none";
    let gradientColor = "inherit";

    if (eStyles?.buttons?.type) {
        switch (eStyles.buttons.type) {
            case "flat":
                borderRadius = `${eStyles.buttons.radius}px`;
                borderRadiusHover = `${eStyles.buttons.radius + ani}px`;
                borderWidth = `${eStyles.buttons.width}px`;
                (eStyles.buttons.shadow || eStyles.buttons.gradient) && (boxShadow = `0 6px 0 ${shadowColor}`);

                break;

            case "leaf":
                if (eStyles.buttons.from === "top-left") {
                    borderRadius = `${eStyles.buttons.radius}px 0 ${eStyles.buttons.radius}px 0`;

                    borderRadiusHover = [
                        `${eStyles.buttons.radius + ani}px 0`,
                        `${eStyles.buttons.radius + ani}px 0`,
                    ].join(" ");

                    (eStyles.buttons.shadow || eStyles.buttons.gradient) && (boxShadow = `6px 6px 0 ${shadowColor}`);
                } else if (eStyles.buttons.from === "top-right") {
                    borderRadius = `0 ${eStyles.buttons.radius}px 0 ${eStyles.buttons.radius}px`;

                    borderRadiusHover = [
                        `0 ${eStyles.buttons.radius + ani}px`,
                        `0 ${eStyles.buttons.radius + ani}px`,
                    ].join(" ");

                    (eStyles.buttons.shadow || eStyles.buttons.gradient) && (boxShadow = `-6px 6px 0 ${shadowColor}`);
                }

                borderWidth = `${eStyles.buttons.width}px`;
                break;

            case "flat":
                // borderRadius = `${es.radius}px`;
                // borderWidth = `${es.width}px`;
                break;
        }

        if (eStyles.withGradient) {
            gradientBorderColor = "transparent !important";
            gradientBackgroundImage = `linear-gradient(90deg, ${palette.primary.initial}, ${palette.secondary.initial})`;
            gradientColor = palette.primary.initialText;
        }
    }

    // JSS
    return {
        "& .button": {
            position: "relative",

            display: "grid",
            gridAutoFlow: "column",
            gridGap: "16px",
            justifyContent: "center",
            alignItems: "center",

            minWidth: "160px",
            height: "48px",
            padding: "0px 24px",
            border: "none",
            background: "transparent",
            fontWeight,
            color: "inherit",

            cursor: "pointer",

            transition: "all 250ms ease",
            "& .button-border-background, .icon": {
                transition: "all 250ms ease",
            },

            "& .icon, .text": {
                pointerEvents: "none",
            },

            "& .icon": {
                width: "24px",
                height: "24px",
                background: "center / contain no-repeat",
            },

            "& .text": {
                position: "relative",
                zIndex: 1,
                fontSize: "20px",
            },

            /*  */
            "& .button-border-background": {
                position: "absolute",
                inset: 0,

                borderWidth,
                borderStyle: "solid",
                borderColor,
                borderRadius,
                background: "transparent center / 110%",
                boxShadow,
            },

            "&:not(.without-gradient) .button-border-background": {
                borderColor: gradientBorderColor,
                backgroundImage: gradientBackgroundImage,
            },

            "&:not(.without-gradient) .text": {
                color: gradientColor,
            },

            "&:hover .button-border-background": {
                inset,
                borderRadius: borderRadiusHover,
            },
        },

        "& .header-primary .text, .primary .text": {
            color: `${palette.primary.initial} !important`,
        },

        "& .header-primary .button-border-background, .primary .button-border-background": {
            backgroundColor: `${palette.primary.initialText} !important`,
        },
    };
}

/**
 * link; text; icon (optional)
 *
 * @param {*} props
 *      children
 *      icon
 *      link
 *      onClick
 *      primaryButton
 *      text
 * @returns
 */
export default function Button(props) {
    const Component = props.onClick ? "button" : "a";

    const LI = useLoremIpsum();

    let link = props.link;
    const linkPattern = /^(https?:\/\/)?([\w-]+\.)+[\w-]+(\/[\w-./?%&=]*)?$/;
    const blankTarget = link && linkPattern.test(link);

    if (blankTarget && !link.startsWith("http://") && !link.startsWith("https://")) {
        link = `https://${props.link}`;
    }

    if (props.onClick) {
        link = null;
    }

    const text = props.text || LI.button.text;

    const CNButton = ["button", "ignore-global"];
    props.primaryButton && CNButton.push("header-primary");

    const elProps = toElementProps(props, { className: CNButton });
    props.type && elProps.type === undefined && (elProps.type = props.type);
    return (
        <Component {...elProps} href={link} onClick={props?.onClick} target={`${(blankTarget && "_blank") || "_self"}`}>
            <div className="button-border-background"></div>

            {props.icon && <div className="icon" style={{ backgroundImage: "url(" + props.icon + ")" }}></div>}
            {text && <div className="text">{text}</div>}

            {props.children}
        </Component>
    );
}
